define([
    "dojo/_base/declare",
    "dojo/dom-class"
], function (declare, domClass) {
    return declare(null, {
        _setGalleryItemRowCountAttr: function (value) {

            domClass.remove(this.domNode, "oneRow");
            domClass.remove(this.domNode, "twoRow");
            domClass.remove(this.domNode, "threeRow");

            if (value === 1) {
                domClass.add(this.domNode, "oneRow");
            } else if (value === 2) {
                domClass.add(this.domNode, "twoRow");
            } else if (value === 3) {
                domClass.add(this.domNode, "threeRow");
            }

            this._set("galleryItemRowCount", value);
        }
    });
});